import { render } from "./PageContact.vue?vue&type=template&id=dd8cde4e"
import script from "./PageContact.vue?vue&type=script&lang=js"
export * from "./PageContact.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_c77b6d3d/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__